<script setup lang="ts">
import VIcon from './v-icon.vue'
</script>

<template>
  <VIcon name="Loading" class="h-4 w-4 animate-spin-fast" />
</template>
